<div class="row mb-2" *ngIf="!global.employeetoAgreementEmit">
    <div class="col p-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent  text-muted">
                <div class="row col-12" *ngIf="Employee.id=='00000000-0000-0000-0000-000000000000'">
                    <div class="col-8">
                        <h4 class="mb-0 font-header">New Employee</h4>
                    </div>

                    <div class="col-2" *ngIf="Employee.id=='00000000-0000-0000-0000-000000000000'">

                        <div class="d-flex  text-right text-end ">
                            <button class="btn btn-sm ms-1  text-right text-end " type="button"
                                [disabled]="
                            saveEmployeeInProgress
                                 ||Employee.firstName==null||Employee.firstName==undefined||Employee.firstName==''
                                 ||Employee.genderLid==null||Employee.genderLid==undefined||Employee.genderLid==''||
                                 Employee.lastName==null||Employee.lastName==undefined||Employee.lastName==''
                                 ||Employee.dOB==null||Employee.dOB==undefined||Employee.dOB==''||
                                 Employee.locationId == '' || Employee.locationId== undefined || Employee.locationId==null || Employee.statusLid == '' 
                                 || Employee.statusLid== undefined || Employee.statusLid==null||
                                 Employee.email==null||Employee.email==undefined||Employee.email=='' ||!userForm.valid ||passerror||
                                 EmployeeDataForm.controls['email'].touched && EmployeeDataForm.controls['email'].invalid
                                 ||Employee.street==null||Employee.street==undefined||Employee.street==''
                                 ||Employee.city==null||Employee.city==undefined||Employee.city==''
                                 ||Employee.steet==null||Employee.steet==undefined||Employee.steet==''
                                 ||Employee.zipcode==null||Employee.zipcode==undefined||Employee.zipcode==''
                                 ||Employee.county==null||Employee.county==undefined||Employee.county==''
                                 " (click)="SaveorUpdateEmployee(Employee)"
                                tabindex="27">Save</button>
                            <button type="button" class="btn btn-sm ms-1  text-right text-end "
                                (click)="backToEmployeeList()" tabindex="28">Close</button>
                        </div>
                    </div>

                    <div class="col-2">
                        <label class="notealert">Note: * fields are mandatory</label>
                    </div>
                </div>
                <div class="row col-12" *ngIf="Employee.id!='00000000-0000-0000-0000-000000000000'">

                    <div class="col-8">
                        <h4 class="mb-0 font-header">Update Employee</h4>
                    </div>

                    <div class="col-2" *ngIf="Employee.id!='00000000-0000-0000-0000-000000000000'">
                        <button type="button" class="btn btn-sm ms-1 " *ngIf="isEditDisable" tabindex="28" [disabled]="!fp?.employeeupdate" 
                            (click)="editFunctionButton()">Edit</button>
                        <button class="btn  btn-sm ms-1 " *ngIf="isShowFields" type="button" [disabled]=" 
                        saveEmployeeInProgress
                            ||Employee.firstName==null||Employee.firstName==undefined||Employee.firstName==''
                            ||Employee.genderLid==null||Employee.genderLid==undefined||Employee.genderLid==''||
                            Employee.lastName==null||Employee.lastName==undefined||Employee.lastName==''
                            ||Employee.dOB==null||Employee.dOB==undefined||Employee.dOB==''||
                           
                            Employee.email==null||Employee.email==undefined||Employee.email==''||User.username == ''||User.username == null||
                            User.username == undefined  || roleName == ''|| roleName == undefined || roleName == null ||
                            Employee.locationId == '' || Employee.locationId== undefined || Employee.locationId==null || Employee.statusLid == '' 
                            || Employee.statusLid== undefined || Employee.statusLid==null||
                            roleName?.length==0||EmployeeDataForm.controls['email'].touched && EmployeeDataForm.controls['email'].invalid
                            ||Employee.street==null||Employee.street==undefined||Employee.street==''
                            ||Employee.city==null||Employee.city==undefined||Employee.city==''
                            ||Employee.steet==null||Employee.steet==undefined||Employee.steet==''
                            ||Employee.zipcode==null||Employee.zipcode==undefined||Employee.zipcode==''
                            ||Employee.county==null||Employee.county==undefined||Employee.county==''"
                            (click)="SaveorUpdateEmployee(Employee)" tabindex="27">Update </button>

                        <button type="button" class="btn  btn-sm ms-1 " (click)="clientvaluechange()"
                            tabindex="28">Close</button>
                    </div>
                    <!-- </div> -->

                    <div class="col-2">
                        <label class="notealert">Note: * fields are mandatory</label>
                    </div>
                </div>
            </div>

            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <!-- for mobile size-->
                <div class="row d-lg-none">
                    <div class="col-lg-12 col-md-12 col-xs-12 ">
                        <div class="row mt-1">
                            <div class="col-lg-3 col-md-4 col-xs-4 form-group   d-inline-flex">
                                <ng-select class="w-100" [(ngModel)]="Employee.statusLid" [searchable]="true"
                                [clearable]="true" (change)="EmployeeChange()" [items]="EmployeestatusList"
                                bindLabel="lovName" [disabled]="global.viewEmployeeTabs" bindValue="id">
                            </ng-select>
                            <sup
                            class="super-script">&nbsp;*</sup>
                            </div>
                            <div class="col-lg-4  col-md-4 col-xs-4 form-group d-inline-flex"
                               >
                                <ng-select class="w-100 col-lg-5" [(ngModel)]="Employee.locationId"
                                name="locationStatus" [searchable]="true" [clearable]="true"
                                (change)="EmployeeChange()" [items]="getLocationList" bindLabel="Value"
                                [disabled]="global.viewEmployeeTabs" bindValue="Key">
                            </ng-select>
                            <sup
                                                                                class="super-script">&nbsp;*</sup>
                                <div *ngIf="global.userID == 00000000-0000-0000-0000-000000000000">
                                    <app-dropdown
                                        (EmitRefreshClick)="refreshToGetDropDownValues('LOCATION_STATUS')"></app-dropdown>
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-4 col-xs-4 ">

                                <label data-bs-toggle="modal" data-bs-target="#showPopup" placement="right"
                                    style="width: 178px;"
                                    class="mr-1 label-bold ">{{Employee.lastName}} , &nbsp;{{Employee.firstName}}&nbsp;{{Employee.middleName}}</label>

                            </div>
                        </div>
                        <div class="row mt-1 ml-0">
                            <div class="col-lg-1 col-md-5 col-xs-5 buttonpaddinglr">
                                <label class="font-weight-bold">DOB:
                                </label>
                            </div>
                            <div class="col-lg-1 col-md-7 col-xs-7 buttonpaddinglr">
                                <label>{{Employee.dob}}</label>
                            </div>
                        </div>
                      
                        
                      
                        <div class="row mt-1 ml-0" *ngIf="Employee.id!='00000000-0000-0000-0000-000000000000'">
                            <button class="btn blue-btn btn-sm ml-2" data-bs-toggle="modal"
                                data-bs-target="#emergencyContactView">Emergency Contact</button>
                        </div>
                        <div class="row mt-1 ml-0" *ngIf="Employee.id!='00000000-0000-0000-0000-000000000000'">
                            <button class="btn blue-btn btn-sm ml-2" data-bs-toggle="modal"
                                data-bs-target="#responsiblepartyConView">Participant's Representative </button>
                        </div>
                    </div>
                </div>
                <!-- for large size -->
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-xs-4 d-none d-lg-block" style="border-right:3px solid  grey">
                        <div class="row mt-1">
                            <!-- status & location -->

                            <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                                <div class="row">
                                    <div class="col-lg-6 col-sm-6 col-md-6 form-group  d-inline-flex">
                                        <ng-select class="w-100" [(ngModel)]="Employee.statusLid" [searchable]="true"
                                [clearable]="true" (change)="EmployeeChange()" [items]="EmployeestatusList"
                                bindLabel="lovName" [disabled]="global.viewEmployeeTabs" bindValue="id">
                            </ng-select>
                            <sup
                            class="super-script">&nbsp;*</sup>
                                    </div>
                                    <div class="col-lg-6 col-sm-6 col-md-6 form-group d-inline-flex"
                                       >
                                        <ng-select class="w-100 col-lg-5" [(ngModel)]="Employee.locationId"
                                        name="locationStatus" [searchable]="true" [clearable]="true"
                                        (change)="EmployeeChange()" [items]="getLocationList" bindLabel="Value"
                                        [disabled]="global.viewEmployeeTabs" bindValue="Key">
                                    </ng-select>
                                    <sup
                                                                                class="super-script">&nbsp;*</sup>
                                        <app-dropdown
                                            (EmitRefreshClick)="refreshToGetDropDownValues('LOCATION_STATUS')"></app-dropdown>
                                    </div>
                                </div>
                            </div>
                            <!-- employee names -->
                            <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 ">
                                <div class="row">
                                    <div class="col-lg-8 col-md-8 col-xs-8 col-sm-8 " style="margin-left: 2px;">
                                        <label data-bs-toggle="modal" data-bs-target="#showPopup" placement="right"
                                            class="mr-1 label-bold ">{{Employee.lastName}} , &nbsp;{{Employee.firstName}}&nbsp;{{Employee.middleName}}</label>
                                    </div>
                                    <!-- <div class="col-lg-2 col-md-2 col-sm-2" [formGroup]="EmployeeDataForm">
                                        <label class="toggle-control">
                                            <input type="checkbox" [(ngModel)]="Employee.isMonitor" (click)="openMonitorModal()"
                                                formControlName="monitor">
                                            <span class="control "></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-1 col-md-1 col-sm-1  mt-1">
                                        <label>Monitor</label>
                                    </div> -->
                                </div>
                            </div>
                        </div>

                       
                        <!-- dob -->
                        <div class="row mt-1 ml-0" style="margin-left: 2px;">
                            <div class="col-lg-2 col-md-5 col-xs-5 buttonpaddinglr">
                                <label class="font-weight-bold">DOB:
                                </label>
                            </div>
                            <div class="col-lg-2 col-md-7 col-xs-7 buttonpaddinglr">
                                <label>{{Employee.dob | date:'MM/dd/yyyy'}}</label>
                            </div>
                        </div>
                       
                    </div>
                  
                  
                    <!-- Emergency Contact -->
                    <div class="col-lg-4 col-md-4 col-xs-4 d-none d-lg-block pl-0" style="border-right:3px solid grey">
                        <div class="row ml-1  mr-1" style="border-bottom:1px solid grey">
                            <label class="headerInfo-label">Emergency Contact</label>
                        </div>
                        <div class="row ml-1 mr-1 d-flex flex-column" *ngFor="let EmergencyCon of EmergencyContactList">
                            <label class="font-header m-0">{{EmergencyCon?.name}}<span *ngIf="EmergencyCon?.relationship !=null">({{EmergencyCon?.relationship}})</span></label>
                            <label class="font-header mb-2">{{EmergencyCon?.phoneNumber}}</label>
                        </div>
                    </div>
                    <!-- ResponsibleParty Contact -->
                    <div class="col-lg-4 col-md-4 col-xs-4 d-none d-lg-block">
                        <div class="row">
                        <div class="row col-12 p-0 ml-1" style="border-bottom:1px solid grey">
                            <label class="headerInfo-label ms-2">Participant's Representative</label>
                        </div>
                        <div class="row ml-1 mr-1 d-flex flex-column" *ngFor="let ResponsibleParty of ResponsiblePartyList">
                            <label class="font-header m-0">{{ResponsibleParty?.name}}<span *ngIf="ResponsibleParty?.relationship !=null">({{ResponsibleParty?.relationship}})</span></label>
                            <label class="font-header mb-2">{{ResponsibleParty?.phoneNumber}}</label>
                        </div>
                        </div>
                       
                    </div>
                </div>
            </div>
            <!--.................................1 rowwwww............................  -->

            <div class="card-body  pb-0 pt-2  mb-4">
                <!-- <div class="row">
                    <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-2">
                                <label class="label-bold ">Status</label>&nbsp;
                            </div>
                            <div class="col-lg-8">
                                <ng-select class="w-100" [(ngModel)]="Employee.statusLid" [searchable]="true"
                                    [clearable]="true" (change)="EmployeeChange()" [items]="EmployeestatusList"
                                    bindLabel="lovName" [disabled]="global.viewEmployeeTabs" bindValue="id">
                                </ng-select>


                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-12 col-md-12 col-xs-12">
                        <div class="row">
                            <div class="col-lg-2">
                                <label class="label-bold ">Location</label>&nbsp;
                            </div>
                            <div class="col-lg-8">
                                <ng-select class="w-100 col-lg-5" [(ngModel)]="Employee.locationId"
                                    name="locationStatus" [searchable]="true" [clearable]="true"
                                    (change)="EmployeeChange()" [items]="getLocationList" bindLabel="Value"
                                    [disabled]="global.viewEmployeeTabs" bindValue="Key">
                                </ng-select>
                            </div>
                        </div>
                    </div>

                </div> -->
            </div>
        </div>
    </div>
</div>



<div class="row mb-2">
    <div class="col p-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body  p-0">
                <section id="tabs" class="project-tab">
                    <div>
                        <div class="row">
                            <div class="col-md-12">
                                <nav *ngIf="!global.employeetoAgreementEmit" class="mt-2">
                                    <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">

                                        <!-- Notes -->
                                        <a class="nav-item nav-link " id="nav-notes-tab" data-bs-toggle="tab"
                                            href="#nav-notes" role="tab" aria-controls="nav-notes"
                                            aria-selected="true" (click)="tabchange('nav-notes');isNotes=true"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000', 'mytab-inactive':activeTab!='nav-notes','active':activeTab=='nav-notes'}">Notes</a>

                                        <a class="nav-item nav-link active " id="nav-GeneralInfo-tab"
                                            data-bs-toggle="tab" href="#nav-GeneralInfo" role="tab"
                                            aria-controls="nav-GeneralInfo" aria-selected="true"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000','mytab-inactive':activeTab!='general','active':activeTab=='general'}"
                                            (click)="tabchange('general')">General
                                        </a>

                                        <a class="nav-item nav-link" id="nav-payorRequiredIds-tab" data-bs-toggle="tab"
                                            *ngIf="fp.payorreqiredidsview" href="#nav-payorRequiredIds" role="tab"
                                            aria-controls="nav-payorRequiredIds"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000','mytab-inactive':activeTab!='payor','active':activeTab=='payor'}"
                                            (click)="tabchange('payor');isEnabledcontact=true;"
                                            aria-selected="false">Payor Required IDs
                                        </a>
                                        <!-- <a class="nav-item nav-link" id="nav-payRate-tab" data-bs-toggle="tab"
                                            href="#nav-payRate" role="tab" aria-controls="nav-profile"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000','mytab-inactive':activeTab!='payrate','active':activeTab=='payrate'}"
                                            aria-selected="false" (click)="tabchange('payrate')">Pay
                                            Rates
                                        </a> -->


                                        <!-- <a class="nav-item nav-link " id="nav-PayRollInformation-tab"
                                            data-bs-toggle="tab" href="#nav-PayRollInformation" role="tab"
                                            aria-controls="nav-PayrollInformation" aria-selected="true"
                                            (click)="tabchange('payrollinformation')"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000' ,
                                             'mytab-inactive':activeTab!='payrollinformation','active':activeTab=='payrollinformation'}">Payroll Information
                                        </a> -->
                                        <a class="nav-item nav-link" id="nav-contactinfo-tab" data-bs-toggle="tab"
                                            href="#nav-contactinfo" role="tab" aria-controls="nav-contactinfo"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000','mytab-inactive':activeTab!='contact','active':activeTab=='contact'}"
                                            (click)="tabchange('contact');" aria-selected="false">Contact
                                        </a>

                                        <a class="nav-item nav-link" id="nav-DocumentInfo-tab" data-bs-toggle="tab"
                                            href="#nav-DocumentInfo" role="tab" aria-controls="nav-DocumentInfo"
                                            [ngClass]="{'disabled':Employee.id==='00000000-0000-0000-0000-000000000000','mytab-inactive':activeTab!='document','active':activeTab=='document'}"
                                            (click)="tabchange('document');isdynamicForm=true;goToAgreement()"
                                            aria-selected="false">Dynamic Employee Form
                                        </a>
                                    </div>

                                </nav>
                                <div class="tab-content" id="nav-tabContent">
                                    <!-- GeneralInfo -->
                                    <div class="tab-pane   " id="nav-GeneralInfo" role="tabpanel"
                                        aria-labelledby="nav-GeneralInfo-tab"
                                        [ngClass]="{'active':activeTab=='general','show':activeTab=='general'}">

                                        <div class="row mb-2 p-0 mt-3">
                                            <div class="col ">

                                                <div widget class="card border-0 box-shadow">
                                                    <div class="card-header transparent text-muted">
                                                        <!-- General Info -->
                                                        <div class="row">
                                                            <div class="col-lg-10">
                                                                <h6 class="mb-0 info-header">General Info</h6>
                                                            </div>

                                                            <!-- <div class="col-lg-2">

                                                                <div class="d-flex  text-right text-end " *ngIf="Employee.id=='00000000-0000-0000-0000-000000000000'">
                                                                    <button class="btn btn-sm ms-1  text-right text-end " type="button"
                                                                        [disabled]="
                                                                    saveEmployeeInProgress
                                                                         ||Employee.firstName==null||Employee.firstName==undefined||Employee.firstName==''
                                                                         ||Employee.genderLid==null||Employee.genderLid==undefined||Employee.genderLid==''||
                                                                         Employee.lastName==null||Employee.lastName==undefined||Employee.lastName==''
                                                                         ||Employee.dOB==null||Employee.dOB==undefined||Employee.dOB==''||
                                                                         Employee.locationId == '' || Employee.locationId== undefined || Employee.locationId==null || Employee.statusLid == '' 
                                                                         || Employee.statusLid== undefined || Employee.statusLid==null||
                                                                         Employee.email==null||Employee.email==undefined||Employee.email=='' ||!userForm.valid ||passerror||
                                                                         EmployeeDataForm.controls['email'].touched && EmployeeDataForm.controls['email'].invalid" (click)="SaveorUpdateEmployee(Employee)"
                                                                        tabindex="27">Save</button>
                                                                   </div>

                                                                   <div class="d-flex  text-right text-end " *ngIf="Employee.id!='00000000-0000-0000-0000-000000000000'">
                                                               
                                                                <button type="button" class="btn btn-sm ms-1 " *ngIf="isEditgeneralDisable" [disabled]="!fp?.employeeupdate"  tabindex="28"
                                                                (click)="editgeneraltabFunctionButton()">Edit</button>
                                                            <button class="btn  btn-sm ms-1 " *ngIf="isShowFields" type="button" [disabled]=" 
                                                            saveEmployeeInProgress
                                                                ||Employee.firstName==null||Employee.firstName==undefined||Employee.firstName==''
                                                                ||Employee.genderLid==null||Employee.genderLid==undefined||Employee.genderLid==''||
                                                                Employee.lastName==null||Employee.lastName==undefined||Employee.lastName==''
                                                                ||Employee.dOB==null||Employee.dOB==undefined||Employee.dOB==''||
                                                               
                                                                Employee.email==null||Employee.email==undefined||Employee.email==''||User.username == ''||User.username == null||
                                                                User.username == undefined  || roleName == ''|| roleName == undefined || roleName == null ||
                                                                Employee.locationId == '' || Employee.locationId== undefined || Employee.locationId==null || Employee.statusLid == '' 
                                                                || Employee.statusLid== undefined || Employee.statusLid==null||
                                                                roleName?.length==0||EmployeeDataForm.controls['email'].touched && EmployeeDataForm.controls['email'].invalid"
                                                                (click)="SaveorUpdateEmployee(Employee)" tabindex="27">Update </button>
                                    
                                                                </div>
                                                            </div> -->


                                                        </div>
                                                    </div>
                                                    <div class="card-body widget-body pt-2">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <div class="row" [formGroup]="EmployeeDataForm">
                                                                    <!-- firstName -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label padding0 col-lg-5">First
                                                                            Name <sup
                                                                                class="super-script">&nbsp;*</sup></label>
                                                                        <input class=" form-control" type="text"
                                                                            formControlName="firstName"
                                                                            [(ngModel)]="Employee.firstName"
                                                                            (change)="EmployeeChange()" id="fname">
                                                                    </div>
                                                                    <!-- middleName -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label col-lg-5 padding0">Middle
                                                                            Name</label>
                                                                        <input class=" form-control" type="text"
                                                                            [(ngModel)]="Employee.middleName"
                                                                            formControlName="middleName"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1" [formGroup]="EmployeeDataForm">
                                                                    <!-- lastName -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label padding0 col-lg-5">Last
                                                                            Name
                                                                            <sup
                                                                                class="super-script">&nbsp;*</sup></label>
                                                                        <input class=" form-control" type="text"
                                                                            formControlName="lastName"
                                                                            [(ngModel)]="Employee.lastName"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                    <!-- (keyup.Tab)="onKey($event,'lastname')" (keydown.Tab)="onKey($event,'gender')" -->
                                                                    <!-- DOB -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label class="label col-lg-5 padding0">DOB<sup
                                                                                class="super-script">&nbsp;*</sup></label>

                                                                        <my-date-picker [options]="myDatePickerOptions"
                                                                            style="width: 300%;"
                                                                            formControlName="dateofBirth"
                                                                            [selDate]="Employee.dOB"
                                                                            placeholder="mm/dd/yyyy"
                                                                            (dateChanged)="onDateChanged($event)"
                                                                            (inputFieldChanged)="DOBdatechange($event,'dob')">
                                                                        </my-date-picker>

                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <!-- Gender -->
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form"
                                                                        [formGroup]="EmployeeDataForm">
                                                                        <label
                                                                            class="label padding0 col-lg-5">Gender<sup
                                                                                class="super-script">&nbsp;*</sup></label>
                                                                        <select class=" form-control"
                                                                            formControlName="genderLid"
                                                                            [(ngModel)]="Employee.genderLid"
                                                                            (change)="EmployeeChange()">
                                                                            <option *ngFor="let val of GenderList"
                                                                                [value]="val.id">
                                                                                {{val.lovName}}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                    <!-- age -->
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label col-lg-5 padding0">Age</label>
                                                                        <input class=" form-control" type="text"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            disabled [(ngModel)]="Employee.age"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-12">
                                                                <div class="row mt-1">
                                                                    <div [formGroup]="EmployeeDataForm"
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">

                                                                        <label
                                                                            class="label  col-lg-5  padding0">Email<sup
                                                                                class="super-script">&nbsp;*</sup></label>
                                                                        <input class=" form-control" type="text"
                                                                            [(ngModel)]="Employee.email"
                                                                            formControlName="email" required
                                                                            (change)="EmployeeChange()">

                                                                    </div>

                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">

                                                                        <label class="label padding0 col-lg-5">Languages

                                                                        </label>
                                                                        <ng-select class="w-100" [multiple]="true"
                                                                        [(ngModel)]="EmployeeselectedLanguages"
                                                                        [searchable]="true" [clearable]="true"
                                                                        [items]="EmployeelanguageList" 
                                                                        [disabled]="isgeneraltabfield"
                                                                        bindLabel="label" bindValue="value"
                                                                        (change)="changefunction()">
                                                                        
                                                                        </ng-select>
                                                                    </div>

                                                                </div>
                                                                <div class="row mt-1">

                                                                    <div class="col-lg-6" style="text-align: center;">
                                                                        <span class="err"
                                                                            *ngIf="EmployeeDataForm.controls['email'].touched && EmployeeDataForm.controls['email'].invalid">
                                                                            <p>*Enter Valid Mail</p>
                                                                        </span>
                                                                    </div>

                                                                </div>
                                                                <div class="row mt-1" [formGroup]="EmployeeDataForm">
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label  col-lg-5 padding0">Phone1</label>
                                                                        <input class=" form-control" type="text"
                                                                            formControlName="phone1"
                                                                            [(ngModel)]="Employee.phone1"
                                                                            (keypress)="keyPress($event)"
                                                                            (ngModelChange)="DemographicPhoneFormat();EmployeeChange"
                                                                            minlength="14" maxlength="14"
                                                                            (change)="changefunction()">
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form"
                                                                        [formGroup]="EmployeeDataForm">
                                                                        <label
                                                                            class="label  col-lg-5  padding0">Phone2</label>
                                                                        <input class=" form-control" type="text"
                                                                            formControlName="phone2"
                                                                            [(ngModel)]="Employee.phone2"
                                                                            (keypress)="keyPress($event)"
                                                                            (ngModelChange)="DemographicPhoneFormat();EmployeeChange"
                                                                            minlength="14" maxlength="14"
                                                                            (change)="changefunction()">
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <div class=" d-flex justify-content-between align-items-center col-lg-5" >
                                                                            <label
                                                                                class="label col-lg-5 padding1">Street<sup class="super-script">*</sup></label>
                                                                            <button type="button " [disabled]="global.viewEmployeeTabs" class="btn blue-btn btn-sm  mb-2 me-2" id="AddressGoogleMap"
                                                                                data-bs-target="#SearchAddress" data-bs-toggle="modal" (click)="AddressGoogleMap = true"> Address
                                                                              </button>
                                                                        </div>
                                                                        <input class=" form-control" type="text"
                                                                            [(ngModel)]="Employee.street"
                                                                            [disabled]="isgeneraltabfield"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label col-lg-5 padding0">APT</label>
                                                                        <input class=" form-control" type="text"
                                                                            [(ngModel)]="Employee.apt"
                                                                            [disabled]="isgeneraltabfield"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            (change)="EmployeeChange()">
                                                                    </div>


                                                                </div>
                                                                <div class="row mt-1">
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label  col-lg-5 padding0">City<sup class="super-script">*</sup></label>
                                                                        <input class=" form-control" type="text"
                                                                            [(ngModel)]="Employee.city"
                                                                            [disabled]="isgeneraltabfield"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label  col-lg-5  padding0">State<sup class="super-script">*</sup></label>
                                                                        <ng-select [items]="stateList" class="w-100"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            [(ngModel)]="Employee.steet"
                                                                            [disabled]="isgeneraltabfield"
                                                                            [selectOnTab]="true" [searchable]="true"
                                                                            [clearable]="true" bindLabel="name"
                                                                            bindValue="abbreviation"
                                                                            (change)="EmployeeChange()">
                                                                        </ng-select>
                                                                    </div>


                                                                </div>
                                                                <div class="row mt-1">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form"
                                                                        [formGroup]="EmployeeDataForm">
                                                                        <label class="label  col-lg-5  padding0">Zip
                                                                            code<sup class="super-script">*</sup></label>

                                                                        <input class=" form-control me-1"
                                                                            (keypress)="keyPress($event)"
                                                                            [(ngModel)]="Employee.zipcode" type="text"
                                                                            minlength="5" maxlength="10"
                                                                            formControlName="zipcode"[disabled]="isgeneraltabfield"
                                                                            (change)="EmployeeChange()">

                                                                            <button type="button" id="EMPEDITgetZip"
                                                                            class=" form-control "
                                                                            [disabled]="isgeneraltabfield ||Employee.street==null||
                                Employee.street==undefined|| Employee.street==''||Employee.city==null||Employee.city==undefined
                                ||Employee.city==''||Employee.steet==null||Employee.steet==undefined||Employee.steet==''"
                                                                            class="btn blue-btn btn-sm "
                                                                            (click)="getZip()">GetZip</button>
                                                                    </div>
                                                                    <div
                                                                        class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <label
                                                                            class="label  col-lg-5 padding0">County<sup class="super-script">*</sup></label>
                                                                        <input class=" form-control" type="text"  autocomplete="new-password"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            [(ngModel)]="Employee.county"
                                                                            [disabled]="isgeneraltabfield"
                                                                            (change)="EmployeeChange()">
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col ms-2">
                                                                      <button type="button " [disabled]="!fp?.employeecredentials" class="btn blue-btn btn-sm ml-2"
                                                                        (click)="EmployeeCredentials = !EmployeeCredentials;">Employee Credentials</button>
                                              
                                              
                                              
                                                                    </div>
                                                                  </div>

                                                                  <div class="row">
                                                                    <div class="col-lg-12" [hidden]="!fp?.employeecredentials">
                                                                      <div *ngIf="EmployeeCredentials">
                                                                        <div class="card-body widget-body pt-1">
                                                                   <hr class="mt-1">


                                                                 
                                                                <div class="row mt-1">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                  <label class="label col-lg-5"> </label>
                                                    
                                                                   
                                                                    <div class="" *ngIf="global.globalAgencyId != '00000000-0000-0000-0000-000000000000' && global.globalAgencyId != '' && global.agencyCode== 'SUPERADMIN'">
                                                                      <div class="row float-start ms-2">
                                                                      
                                                                        <div class="col-lg-6">
                                                                          <div class="row me-3">
                                                                            <div class="d-inline-flex">
                                                                              <input [(ngModel)]="RoleType" (ngModelChange)="RoleTypeChange()" type="radio" id="Internal"
                                                                                name="RoleType" value="Internal" class="mt-1 ms-1" [disabled]="isgeneraltabfield || (isAgencyAdmin && global.agencyCode?.toUpperCase() != 'SUPERADMIN')">&nbsp;
                                                                                <label for="SuperAdminRole" class="mt-1">Internal</label>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                        <div class="col-lg-6">
                                                                          <div class="row ms-2">
                                                                            <div class="d-inline-flex">
                                                                              <input [(ngModel)]="RoleType" (ngModelChange)="RoleTypeChange()" type="radio" id="Global"
                                                                                name="RoleType" value="Global" class="mt-1 ms-1" [disabled]="isgeneraltabfield || (isAgencyAdmin && global.agencyCode?.toUpperCase() != 'SUPERADMIN')">&nbsp;
                                                                                <label for="EvvRole" class="mt-1">AgencyAdmin</label>
                                                                            </div>
                                                                           
                                                                          </div>
                                                                        </div>
                                                                       
                                                                        
                                                                      </div>
                                                                    </div>
                                                          
                                                               
                                                                    </div>
                                                                   
                                                                 
                                                                  </div>
                                                                  <div class="row mt-1">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                
                                                                    <div class="col-lg-5">
                                                                      <label>Role<span class="super-script">*</span></label>
                                                                    </div>
                                                                    <div class="col-lg-7" [formGroup]="userForm">
                                                                      <ng-select  [(ngModel)]="roleName" [multiple]="true"  [disabled]="isgeneraltabfield || global.globalroleName == 'Consultation Admin' " formControlName="Role" [searchable]="true"  
                                                                        [clearable]="true" (change)="onvalChange()">
                                                                        <ng-container *ngFor="let ur of UserRole">
                                                                            <ng-option *ngIf="global.agencyCode.toUpperCase() != 'SUPERADMIN'? ( isAgencyAdmin == true  ? (ur.isInternal == false&& ur.isSuperAdmin ==false) : ur.isInternal == true)   :  (ur.isInternal == this.isInternalRole)" [value]="ur.id">
                                                                                <!-- <ng-option  [value]="ur.id"> -->
                                                                          
                                                                                {{ur.roleName}}
                                                                          </ng-option>
                                                                        </ng-container>
                                                                      </ng-select>
                                                                     <!-- <ng-select [(ngModel)]="roleName" [multiple]="true" formControlName="Role" [searchable]="true" [items]="UserRole" bindLabel="roleName" bindValue="id"
                                                                        [clearable]="true" (change)="onvalChange()">
                                                                      
                                                                      </ng-select> -->
                                                                     </div>
                                                                    </div>
                                                                  </div>
                                                                  <span class="help-block text-danger text-center"
                                                                    *ngIf="!userForm.get('Role').valid && userForm.get('Role').touched">
                                                                    <p>Role is required</p>
                                                                  </span>


                                                                  <!-- <hr class="mt-1"> -->
                                                                  <div class="row mt-1">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                
                                                                    <div class="col-lg-5">
                                                                      <label>User Name<sup class="super-script">*</sup></label>
                                                                    </div>
                                                                    <div class="col-lg-7 ms-0" [formGroup]="userForm">
                                                                      <input type="text" class="form-control" autocomplete="off" formControlName="UserName"
                                                                        [(ngModel)]="User.username"  (change)="onvalChange()"  (keypress)="isalphanumbericonly($event)"
                                                                        [disabled]="isgeneraltabfield" >
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                  <span class="help-block text-danger text-center"
                                                                    *ngIf="!userForm.get('UserName').valid && userForm.get('UserName').touched">
                                                                    <p>User Name is required</p>
                                                                  </span>
                                                                  <div class="row mt-1" *ngIf="Employee.id=='00000000-0000-0000-0000-000000000000'" >
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                
                                                                    <div class="col-lg-5" >
                                                                      <label>Password<sup class="super-script">*</sup></label>
                                                                    </div>
                                                                    <div class="col-lg-7 ms-0" [formGroup]="userForm">
                                                                      <input type="password" autocomplete="new-password" class="form-control" formControlName="Password"
                                                                        [(ngModel)]="User.password" (keyup)="passvalid($event)" (change)="onvalChange()" 
                                                                        [disabled]="isgeneraltabfield" >
                                                                    </div>
                                                                  </div>
                                                                </div>

                                                                <div class="row mt-1" *ngIf="Employee.id!='00000000-0000-0000-0000-000000000000'" >
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                                                                        <button class="btn blue-btn btn-sm ml-2" data-bs-toggle="modal"  [disabled]="isgeneraltabfield"
                                                                        data-bs-target="#Reset_Confirmation" >Change Password </button>
                                                                  </div>
                                                                </div>
                                                                  <span class="help-block text-danger text-center"
                                                                    *ngIf="!userForm.get('Password').valid && userForm.get('Password').touched">
                                                                    <p>Password is required</p>
                                                                  </span>
                                                                  <span class="help-block text-danger text-center" *ngIf="passerror && resetPass.get('Password').valid">
                                                                    <p>Enter valid password</p>
                                                                  </span>
                                                                  <div class="row mt-12">
                                                                    <label class="ms-1 notealert"><i>Note:&nbsp;Password should contain atleast 8 characters/
                                                                        digits includes 1 special character, 1 lower and uppercase characters
                                                                      </i></label>
                                                                  </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                          </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="tab-pane   " id="nav-payorRequiredIds" role="tabpanel"
                                        aria-labelledby="nav-payorRequiredIds-tab"
                                        [ngClass]="{'active':activeTab=='payor','show':activeTab=='payor'}">
                                        <app-payor-required-ids-list
                                            *ngIf="isPayorRequiredEdit==false&&Employee.id!='00000000-0000-0000-0000-000000000000'"
                                            (IsViewEditpayorequired)="dataEmitfromChild($event)"
                                            [employeeId]="Employee.id"></app-payor-required-ids-list>
                                    </div>

                                    <!-- NOTES...................... -->


                                    <div class="tab-pane fade" id="nav-notes" role="tabpanel"
                                        aria-labelledby="nav-notes-tab"
                                        [ngClass]="{'active':activeTab=='notes','show':activeTab=='notes'}">


                                    </div>


                                    <!--..........PAYROLL...................  -->



                                    <div class="tab-pane " id="nav-PayrollInformation" role="tabpanel"
                                        aria-labelledby="nav-PayrollInformation-tab"
                                        [ngClass]="{'active':activeTab=='payrollinformation','show':activeTab=='payrollinformation'}">

                                        <app-employee-payroll *ngIf="ispayrollinformation" [EmployeeId]="Employee.id">
                                        </app-employee-payroll>

                                    </div>


                                    <!-- payRate -->
                                    <div class="tab-pane " id="nav-payRate" role="tabpanel"
                                        aria-labelledby="nav-payRate-tab"
                                        [ngClass]="{'active':activeTab=='payrate','show':activeTab=='payrate'}">

                                        <app-pay-rates-list *ngIf="isPayRateEdit==false"
                                            (IsViewEditpayrate)="dataEmitfromPayrate($event)"
                                            [payratevalueChange]="Employee.id"></app-pay-rates-list>
                                    </div>
                                    <!-- ContactInfo -->
                                    <div class="tab-pane " id="nav-contactinfo" role="tabpanel"
                                        aria-labelledby="nav-contactinfo-tab"
                                        [ngClass]="{'active':activeTab=='contact','show':activeTab=='contact'}">
                                        <div class="row mt-3 mr-0 ">



                                            <div class="row ml-3 mt-3">


                                            </div>
                                            <div>
                                                <div class="row  mr-0">
                                                    <div class="col-lg-12 text-right ">
                                                        <button class="btn blue-btn btn-sm" data-bs-toggle="modal"
                                                            data-bs-target="#modalSaveOrUpdate"
                                                            [disabled]="this.global.viewEmployeeTabs">Add
                                                            Contact</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <!-- RelationshipInfo -->
                                    <div class="tab-pane   " id="nav-RelationshipInfo" role="tabpanel"
                                        aria-labelledby="nav-RelationshipInfo-tab"
                                        [ngClass]="{'active':activeTab=='Relationship','show':activeTab=='Relationship'}">

                                    </div>
                                    <!-- DocumentInfo -->
                                    <div class="tab-pane" id="nav-DocumentInfo" role="tabpanel"
                                        aria-labelledby="nav-DocumentInfo-tab"
                                        [ngClass]="{'active':activeTab=='document','show':activeTab=='document'}">
                                        <div class="col-12 p-0">
                                            <!--*ngIf="isdynamicFormcontact" <app-employee-agreementlist *ngIf="OnboardListemitBo.employeeToDocument"
                                                [agreementemitBo]="OnboardListemitBo"
                                                (dataEmitFromemployee)="dataEmitFromOnboard($event)">
                                            </app-employee-agreementlist> -->
                                        </div>
                                    </div>

                                </div>
                                <app-client-employee-contact [ContactRelation]="ClientEmployeeContact"
                                    *ngIf="isRelationcontact">
                                </app-client-employee-contact>

                                <app-client-employee-relationship [CERelation]="ClientEmployeeRelationship"
                                    *ngIf="isRelationShip">
                                </app-client-employee-relationship>

                                <app-employee-notes *ngIf="isNotes" [Employee]="Employee">
                                </app-employee-notes>


                                <app-client-employee-dynamicform *ngIf="isdynamicForm"
                                    [DynamicFormRelation]="ClientEmployeeDynamicForm">
                                </app-client-employee-dynamicform>




                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>
<span id="closessnModal" data-bs-target="#SSNModel" data-bs-toggle="modal"></span>
<div class="modal fade " id="SSNModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Social Security Number</h5>
                <button type="button" class="btn-close" (click)="closeSsnValidation()" [disabled]="ssnerr"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-2">
                        <label class="label-bold">SSN&nbsp;:</label>
                    </div>
                    <div class="col-lg-10">
                        <input type=" text" [(ngModel)]="Employee.sSN" class="form-control"
                            (keypress)="keyPress($event)" minlength=9 maxlength=9 (ngModelChange)="EmployeeChangeSSN()">
                    </div>

                </div>
                <div class="col offset-2 mt-1">
                    <span class="col-8 offset-2 help-block text-danger " *ngIf="ssnerr">
                        <p>Enter Valid SSN Number</p>
                    </span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" [disabled]="ssnerr"
                    (click)="closeSsnValidation()">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="sendToEmploye" data-bs-toggle="modal" data-bs-target="#sendToEmployee"></span>
<div class="modal fade" id="sendToEmployee" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Mail Notes</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <p>Email :<b>{{Employee.email}}</b></p>
                <label>UserName<sup class="super-script">*</sup></label>
                <input class="form-control" [(ngModel)]="portalBo.username">
                <label class="mx-auto mt-3" style="font-size: 12px; color: red;"><i
                        class="fa fa-info-circle fa-lg"></i>&nbsp;
                    This will be attached above in this mail</label>

                <textarea class="form-control" [(ngModel)]="portalBo.agencyNote"> </textarea>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn  btn-sm"
                    [disabled]="portalBo.username==null||portalBo.username==undefined|| portalBo.username==''"
                    (click)="SentToEmployeePortal()">Submit</button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<span id="openEvvModal" data-bs-target="#EnableEvv" data-bs-toggle="modal">
</span>
<div class="modal fade" id="EnableEvv" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="font-header">
                    Disable EVV</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"
                    (click)="Employee.requiredEVV=!Employee.requiredEVV"> </button>
            </div>
            <div class="modal-body">
                <label *ngIf="!Employee.requiredEVV "> This will log out all the sessions for this user!</label>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-sm" (click)="passwordResetFunction()">Continue</button>
                <button type="button" class="btn btn-primary btn-sm" data-bs-dismiss="modal"
                    (click)="Employee.requiredEVV=!Employee.requiredEVV">No</button>
            </div>
        </div>
    </div>
</div>

<!---------------------------payor required Id edit -------------------------------------------------------------->
<app-payor-required-ids-edit *ngIf="isPayorRequiredEdit==true&&editEmployeeId!='00000000-0000-0000-0000-000000000000'"
    (IsViewEditpayorequired)="dataEmitfromChild($event)" [payoRequiredViewEditdata]="payoRequiredViewEdit">
</app-payor-required-ids-edit>

<app-pay-rates-edit *ngIf="isPayRateEdit==true&&editEmployeeId!='00000000-0000-0000-0000-000000000000'"
    (IsViewEditpayrate)="dataEmitfromPayrate($event)" [payrateevntchange]="payrateview">

</app-pay-rates-edit>

<span id="cancelmodal" data-bs-toggle="modal" data-bs-target="#CloseModal"></span>
<div class="modal fade" id="CloseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog create-update-zip " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        You want to close without save?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="backToEmployeeList()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade " id="showPopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Employee Details</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-2">
                        <label class="modal-title font-header">Name:<sup class="super-script"></sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <label>{{Employee.lastName}}&nbsp;{{Employee.firstName}}&nbsp;{{Employee.middleName}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2">
                        <label class="modal-title font-header">Address:<sup class="super-script"></sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <label>{{Employee.street}}&nbsp;{{Employee.apt}}</label><br>
                        <label>{{Employee.city}}</label><br>
                        <label>{{Employee.steet}}&nbsp; {{Employee.zipcode}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2">
                        <label class="modal-title font-header">Email:<sup class="super-script"></sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <label> {{Employee.email}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2">
                        <label class="modal-title font-header">Phone:<sup class="super-script"></sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <label> {{Employee.phone1}}</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- responsiblepartyConView -->
<span id="responsiblepartyModalId" data-bs-toggle="modal" data-bs-target="#responsiblepartyConView"></span>
<div class="modal hide fade modalbackgrod" id="responsiblepartyConView" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <div class="row w-100">
                    <div class="col-lg-9">
                        <h5 class="modal-title font-header" id="exampleModalLabel">Participant's Representative </h5>
                    </div>
                </div>
            </div>
            <div class="modal-body  Scrolling">
                <table
                    style="width:100%;text-align:center; border:1px solid lightgray;max-height:90%;overflow-y:scroll;">
                    <tr style="background-color:#00786a; color:white;border:1px solid lightgray;">
                        <th>Name</th>
                        <th>Relationship</th>
                        <th>PhoneNumber</th>
                    </tr>
                    <tr *ngFor="let ResponsibleParty of ResponsiblePartyList" style="border:1px solid lightgray;">
                        <td>{{ResponsibleParty.name}}</td>
                        <td>{{ResponsibleParty.relationship}}</td>
                        <td>{{ResponsibleParty.phoneNumber}}</td>
                    </tr>
                </table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<!-- EmergencyConConView -->
<span id="emergencyContactModalId" data-bs-toggle="modal" data-bs-target="#emergencyContactView"></span>
<div class="modal hide fade modalbackgrod" id="emergencyContactView" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <div class="row w-100">
                    <div class="col-lg-9">
                        <h5 class="modal-title font-header" id="exampleModalLabel">EmergencyContact </h5>
                    </div>
                </div>
            </div>
            <div class="modal-body  Scrolling">
                <table
                    style="width:100%;text-align:center; border:1px solid lightgray;max-height:90%;overflow-y:scroll;">
                    <tr style="background-color:#00786a; color:white;border:1px solid lightgray;">
                        <th>Name</th>
                        <th>Relationship</th>
                        <th>PhoneNumber</th>
                    </tr>
                    <tr *ngFor="let EmergencyCon of EmergencyContactList" style="border:1px solid lightgray;">
                        <td>{{EmergencyCon.name}}</td>
                        <td>{{EmergencyCon.relationship}}</td>
                        <td>{{EmergencyCon.phoneNumber}}</td>
                    </tr>
                </table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- ============================Reset Password Confirmation Model========================================== -->
<span data-bs-toggle="modal" data-bs-target="#Reset_Confirmation" id="resetmodalConfirmation"></span>
<div class="modal fade " id="Reset_Confirmation" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">

  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Reset Password</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        Do you want to reset your password?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-toggle="modal"
          data-bs-target="#ResetPwdmodal">Yes</button>
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-target="#Reset_Confirmation">No</button>
      </div>
    </div>
  </div>
</div>

<!-- ============================Reset Password Model========================================== -->
<span data-bs-toggle="modal" data-bs-target="#ResetPwdmodal" id="resetmodal"></span>
<div class="modal fade " id="ResetPwdmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Password Confirmation</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="resetPass">
          <div class="row">
            <div class="col-lg-2">
              <label>Password<sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-5">
              <input type="password" class="form-control" formControlName="Password" [(ngModel)]="ResetPassword"
                (keyup)="passvalid($event)" >
              <span class="help-block text-danger text-center"
                *ngIf="!resetPass.get('Password').valid && resetPass.get('Password').touched">
                <p>Password is required</p>
              </span>
              <span class="help-block text-danger text-center" *ngIf="passerror && resetPass.get('Password').valid">
                <p>Enter valid password</p>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <label><i>Note:&nbsp;Password should contain atleast 8 characters/
                  digits includes 1 special character, 1 lower and uppercase characters
                </i></label>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" [disabled]="!resetPass.valid ||passerror"
          (click)="ResetPasswrd('Success')">Save & Close</button>
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-target="#ResetPwdmodal">Close</button>
      </div>
    </div>
  </div>
</div>
<span id="openSearchAddressModal" data-bs-target="#SearchAddress" data-bs-toggle="modal">
</span>
<div class="modal fade" id="SearchAddress" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="font-header">
          Search Address</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="AddressGoogleMap=false;" id="AddressGoogleMap"></button>
      </div>
      <div class="modal-body" style="min-height: 100px;">
        <div class="row">
          <div class="col-lg-12">
            <app-google-map *ngIf="AddressGoogleMap==true" (GoogleMapEmit)="EmitGoogleMapComponent($event)"></app-google-map>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-sm"  data-bs-dismiss="modal" id="AddressGoogleMapbtn"
          (click)="AddressGoogleMap=false">Close</button>
      </div>
    </div>
  </div>
</div>
